<template lang='pug' src='./hero-page.pug'></template>

<script>
export default {
  props: ['props'],
  data () {
    return {
      triggers: false,
      active: false,
      line2: false,
      line3: false,
      line4: false
    }
  },
  mounted () {
    setTimeout(() => {
      this.active = true
    }, 500)
  },
  methods: {
    stringToArrayTitle (i) {
      let textArr = i.split('')
      return textArr
    },
    currentMath (i) {
      let length = this.stringToArrayTitle(i).length - 1
      let sum = length * 0.01 + 0.5
      return sum
    }
  }
}
</script>



// WEBPACK FOOTER //
// hero-page.vue?8f7b79e6